import { render } from "./FormasPagamento.vue?vue&type=template&id=06721e13&scoped=true"
import script from "./FormasPagamento.vue?vue&type=script&lang=js"
export * from "./FormasPagamento.vue?vue&type=script&lang=js"

import "./FormasPagamento.vue?vue&type=style&index=0&id=06721e13&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06721e13"]])

export default __exports__